import React from 'react';
import { PlusCircle, HelpCircle } from 'lucide-react';

/**
 * Компонент секции дополнительных услуг
 */
const AdditionalServicesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-100 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-4 flex items-center">
        <PlusCircle className="w-5 h-5 mr-2 text-purple-500" />
        Дополнительные услуги
      </h3>
      
      <div className="grid grid-cols-1 gap-4">
        {/* Сервисный сбор */}
        <div className="flex items-center justify-between">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="includeVAC"
              name="includeVAC"
              checked={formData.includeVAC}
              onChange={handleInputChange}
              className="form-checkbox mt-0.5"
            />
            <label htmlFor="includeVAC" className="ml-2">
              <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Сервисный сбор визового центра
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Обязательный сбор для подачи документов через визовый центр
              </div>
            </label>
          </div>
          <div className="ml-2 flex items-center" title="Стандартный сервис визового центра включает прием документов, сбор биометрических данных, проверку комплектации и передачу в консульство.">
            <HelpCircle className="w-4 h-4 text-gray-400" />
          </div>
        </div>

        {/* Туристическая страховка */}
        <div className="flex items-center justify-between">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="includeInsurance"
              name="includeInsurance"
              checked={formData.includeInsurance}
              onChange={handleInputChange}
              className="form-checkbox mt-0.5"
            />
            <label htmlFor="includeInsurance" className="ml-2">
              <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Туристическая страховка
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Медицинская страховка на период поездки (обязательна для большинства стран)
              </div>
            </label>
          </div>
          <div className="ml-2 flex items-center" title="Медицинская страховка, покрывающая расходы на лечение, госпитализацию и репатриацию. Для шенгенских стран требуется покрытие минимум 30 000 евро.">
            <HelpCircle className="w-4 h-4 text-gray-400" />
          </div>
        </div>

        {/* Перевод документов */}
        <div className="flex items-center justify-between">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="includeTranslation"
              name="includeTranslation"
              checked={formData.includeTranslation}
              onChange={handleInputChange}
              className="form-checkbox mt-0.5"
            />
            <label htmlFor="includeTranslation" className="ml-2">
              <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Перевод документов
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Перевод и заверение документов на язык страны назначения
              </div>
            </label>
          </div>
          <div className="ml-2 flex items-center" title="Нотариально заверенный перевод документов на официальный язык посольства (паспорт, справки с работы, выписки со счетов и др.)">
            <HelpCircle className="w-4 h-4 text-gray-400" />
          </div>
        </div>

        {/* Доставка документов */}
        <div className="flex items-center justify-between">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="includeDelivery"
              name="includeDelivery"
              checked={formData.includeDelivery}
              onChange={handleInputChange}
              className="form-checkbox mt-0.5"
            />
            <label htmlFor="includeDelivery" className="ml-2">
              <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Доставка паспорта с визой
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Курьерская доставка документов после получения визы
              </div>
            </label>
          </div>
          <div className="ml-2 flex items-center" title="Курьерская доставка паспорта с визой на указанный адрес после рассмотрения заявления консульством.">
            <HelpCircle className="w-4 h-4 text-gray-400" />
          </div>
        </div>

        {/* Сервисный сбор (VIP) */}
        <div className="flex items-center justify-between opacity-50">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="includeServiceFee"
              name="includeServiceFee"
              checked={formData.includeServiceFee}
              onChange={handleInputChange}
              className="form-checkbox mt-0.5"
              disabled
            />
            <label htmlFor="includeServiceFee" className="ml-2">
              <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                VIP-обслуживание
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Персональный менеджер, отдельный зал, приоритетная подача
              </div>
            </label>
          </div>
          <div className="ml-2 flex items-center" title="Премиальное обслуживание с персональным менеджером, отдельным залом ожидания и приоритетной подачей документов. Доступно не для всех стран.">
            <HelpCircle className="w-4 h-4 text-gray-400" />
          </div>
        </div>
      </div>

      {/* Валюта оплаты */}
      <div className="mt-6">
        <label htmlFor="paymentCurrency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Валюта для расчета
        </label>
        <select
          id="paymentCurrency"
          name="paymentCurrency"
          value={formData.paymentCurrency}
          onChange={handleInputChange}
          className="form-select w-full md:w-1/2"
        >
          <option value="rub">Российский рубль (₽)</option>
          <option value="usd">Доллар США ($)</option>
          <option value="eur">Евро (€)</option>
        </select>
        <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Сборы будут пересчитаны по актуальному курсу на основе выбранной валюты
        </div>
      </div>
    </div>
  );
};

export default AdditionalServicesSection;